<template>
  <div class="grid grid-cols-6 xl:grid-cols-4 gap-4 max-w-7xl mx-auto px-6 py-6">
    <div class="col-span-full">
      <Button data-cy="refresh-all-button" severity="secondary" @click="refreshAll(true)" :label="$t('common.refresh_all')"/>
    </div>

    <AssetDashboardCard
        class="col-span-2 xl:col-span-1"
        :value="assetsDashboardPageStore?.getAssetsTotalCount"
        :loading="assetsDashboardPageStore?.getAssetsTotalCountLoading"
    />
    <AssetDashboardCard
        :subtitle="$t('pages.assets.dashboard.without_devices')"
        class="col-span-2 xl:col-span-1"
        :value="assetsDashboardPageStore.getAssetsWithoutDevicesCount"
        :loading="assetsDashboardPageStore?.getAssetsWithoutDevicesCountLoading"
    />
    <AssetDashboardCard
        :subtitle="$t('pages.assets.dashboard.awaiting_an_update')"
        class="col-span-2 xl:col-span-1"
        :value="assetsDashboardPageStore.getAssetsNeedingAnUpdateCount"
        :loading="assetsDashboardPageStore?.getAssetsNeedingAnUpdateCountLoading"
    />

    <AssetsList
        :value="assetsDashboardPageStore.getAssetsNeedingAnUpdate"
        :loading="assetsDashboardPageStore?.getAssetsNeedingAnUpdateLoading"
        :first="assetsDashboardPageStore?.getFirstPage('assets_needing_an_update')"
        :rows="assetsDashboardPageStore?.assets_needing_an_update.params.per_page"
        @page="$event => assetsDashboardPageStore.onPage($event)"
        :total-records="assetsDashboardPageStore?.assets_needing_an_update.totalRecords"
        :subtitle="$t('pages.assets.dashboard.awaiting_an_update')"
        class="row-start-3 col-span-6 xl:row-start-auto xl:row-span-2 xl:col-span-1 h-[28rem]"
    />

    <AssetsOverTime
        class="row-start-2 col-span-4 xl:row-start-auto xl:col-span-2"
        :data="assetsDashboardPageStore.getAssetsCountOverTime"
        :loading="assetsDashboardPageStore?.getAssetsCountOverTimeLoading"
    />

    <AssetsUpToDateVsRequired
        :data="assetsDashboardPageStore.getAssetsUpToDateVsNeedingAnUpdate"
        :loading="assetsDashboardPageStore?.getAssetsUpToDateVsNeedingAnUpdateLoading"
        class="row-start-2 col-start-5 col-span-2 xl:row-start-auto xl:col-start-auto xl:col-span-1"
    />
  </div>
</template>

<script>
import {IconRouterOff} from '@tabler/icons-vue';
import {mapStores} from "pinia";
import AssetsOverTime from "@/Widgets/Charts/AssetsOverTime.vue";
import AssetsUpToDateVsRequired from "@/Widgets/Charts/AssetsUpToDateVsRequired.vue";
import AssetDashboardCard from "@/Widgets/Cards/AssetDashboardCard.vue";
import AssetsList from "@/Widgets/Lists/AssetsList.vue";
import {useAssetsDashboardPageStore} from "@/stores/pages/assetsDashboardPage.js";

export default {
  name: "AssetsDashboard",
  components: {
    AssetsList,
    AssetDashboardCard,
    IconRouterOff,
    AssetsOverTime,
    AssetsUpToDateVsRequired
  },
  computed: {
    ...mapStores(useAssetsDashboardPageStore),
  },
  methods: {
    refreshAll(forceRefresh = false) {
      try {
        this.assetsDashboardPageStore.fetchAssetCount({}, forceRefresh);
        this.assetsDashboardPageStore.fetchAssetsWithoutDevicesCount({}, forceRefresh);
        this.assetsDashboardPageStore.fetchAssetsNeedingAnUpdate({}, forceRefresh);
        this.assetsDashboardPageStore.fetchAssetsCountOverTime({}, forceRefresh);
        this.assetsDashboardPageStore.fetchAssetsUpToDateVsNeedingAnUpdate({}, forceRefresh);
      } catch (e) {
        console.log(e);
      }
    }
  },
  mounted() {
    this.refreshAll();
  }
}
</script>

<style scoped>

</style>